import { Grid, Button, Link, Typography } from '@material-ui/core';
import SelectPicture from 'components/SelectPicture';
import { toBlob } from 'html-to-image';
import React, { MutableRefObject, useContext } from 'react';
import Context from 'context';
import { Colors } from 'type';
import ColorPicker from './ColorPicker';

type ControllerProps = {
  chartRef: MutableRefObject<HTMLDivElement | null>;
};

const Controller = ({ chartRef }: ControllerProps) => {
  const { addDate, removeDate, colors, setColors } = useContext(Context);

  const updateColors = (color: string, index: number) => {
    const newColor = [...colors];
    newColor[index] = color;
    setColors(newColor);
  };

  return (
    <Grid container direction='column' style={{ width: '800px' }}>
      <br />
      <Grid item container spacing={1}>
        <Grid item xs={6}>
          <Button
            variant='outlined'
            color='primary'
            onClick={(e) => addDate()}
            fullWidth
          >
            + เพิ่ม
          </Button>
        </Grid>
        <Grid item xs={6}>
          <Button
            variant='outlined'
            color='secondary'
            onClick={(e) => removeDate()}
            fullWidth
          >
            - ลบแถวล่างสุด
          </Button>
        </Grid>
      </Grid>
      <br />
      <ColorPicker />
      <Grid item>
        <br />
        <SelectPicture />
      </Grid>
      <Grid item>
        <br />
        <Button
          variant='contained'
          color='primary'
          onClick={(e) => {
            try {
              (window as any).gtag('event', 'download');
            } catch (e) {
              console.warn(e);
            }
            chartRef.current &&
              toBlob(chartRef.current, {
                backgroundColor: colors[Colors.Background],
                width: 800,
                height: 800,
                pixelRatio: 1,
              }).then(function (blob) {
                const url = URL.createObjectURL(blob);
                window.open(url, '_blank');
              });
          }}
          fullWidth
        >
          DOWNLOAD
        </Button>
      </Grid>
      <Grid item style={{ textAlign: 'right' }}>
        <br />
        <Link
          href='https://forms.gle/haTaSuRVzNb41q278'
          target='_blank'
          rel='noopener'
        >
          Feedback ส่งความคิดเห็น
        </Link>
      </Grid>
    </Grid>
  );
};

export default Controller;
